import { useState } from "react"
import { useSnackbar } from "notistack"
import { ContextMenuItem } from "lib/@components/context-menu-bar/context-menu-item"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { moveScheduleCommentaryCategory } from "../controller/move-schedule-commentary-category"

// Only shown once a schedule's been moved away from where it started - reuses the Move mutation
// rather than a dedicated one, since a revert is just a move back to originalCategory.
export function ScheduleCommentaryRevertCategoryMenuItem({ item }) {
    const { enqueueSnackbar } = useSnackbar()
    const [reverting, setReverting] = useState(false)
    const { commentarySections = [] } = useBoundContext()

    if (item.sectionId === item.originalCategory) return null

    return (
        <ContextMenuItem
            icon="mdi:restore"
            label="Revert to original category"
            disabled={reverting}
            onClick={handleRevert}
        />
    )

    async function handleRevert() {
        setReverting(true)
        try {
            await moveScheduleCommentaryCategory({ id: item.id, category: item.originalCategory })
            const section = commentarySections.find((candidate) => candidate.id === item.originalCategory)
            enqueueSnackbar(`Reverted to ${section?.title ?? "original category"}`, { variant: "success" })
        } catch (error) {
            enqueueSnackbar(error.message || "Failed to revert schedule", { variant: "error" })
        } finally {
            setReverting(false)
        }
    }
}
